import { DataResponse } from "shared/models";
import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";

export const partnerService = createApi({
  reducerPath: "partnerService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getPartners: builder.query<
      any,
      { page: number; limit: number; search: string; skip_log?: boolean }
    >({
      query: (params) => ({
        url: `/partner-management?page=${params?.page}&limit=${
          params?.limit
        }&sortBy=business_name&search=${params?.search}&order=asc&skip_log=${
          params?.skip_log ? params?.skip_log : false
        }`,
        method: "GET",
        headers: !params?.skip_log
          ? {
              PageName: "Partner Management",
            }
          : {},
      }),
    }),

    getPartnerSelect: builder.query<
      any,
      { page: number; limit: number; search: string; skip_log?: boolean ; type?: number}
    >({
      query: (params) => ({
        url: `/partner-management`,
        params,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData?.success) {
          const data = rawData?.data
            .map((raw: any) => ({
              value: raw.id,
              merchants_count: raw.merchants_count,
              name: raw.trading_name,
            }))
            .sort((a: any, b: any) => a?.name.localeCompare(b?.name));
          return { data, pagination: rawData.meta };
        }
      },
    }),

    getDetailPartner: builder.query<DataResponse<any>, { partnerId?: string; skip_log?: boolean }>({
      query: (params) => ({
        url: `/partner-management/${params?.partnerId}?skip_log=${
          params?.skip_log ? params?.skip_log : false
        }`,
        method: "GET",
        headers: !params?.skip_log
          ? {
              PageName: "Partner Management",
            }
          : {},
      }),
    }),
    getMerchantLinkPartner: builder.query<DataResponse<any>, { partnerId?: string; merchants?: number[] }>(
      {
        query: (params) => {
          const searchParams = new URLSearchParams();
          if (params?.merchants?.length) {
            params.merchants.forEach(id => {
              searchParams.append('merchants[]', id.toString());
            });
          }
          return {
            url: `/partner-management/${params?.partnerId}/merchant-link-partner?${searchParams.toString()}`,
            method: 'GET',
            headers: !params?.merchants?.length
              ? { PageName: 'Partner Management' }
              : {},
          };
        },
      }
    ),
    createPartner: builder.mutation<DataResponse<any>, any>({
      query: (body: any) => ({
        url: "/partner-management",
        body,
        method: "POST",
        headers: {
          PageName: "Partner Management",
        },
      }),
    }),
    updatePartner: builder.mutation<DataResponse<any>, any>({
      query: ({ id, ...others }) => ({
        url: `/partner-management/${id}`,
        body: { ...others },
        method: "PUT",
        headers: {
          PageName: "Partner Management",
        },
      }),
    }),
    addMerchantsToPartner: builder.mutation<DataResponse<any>, any>({
      query: ({ id, merchants }) => ({
        url: `/partner-management/${id}/add-merchant`,
        body: { merchants },
        method: "PUT",
        headers: {
          PageName: "Partner Management",
        },
      }),
    }),
    deletePartner: builder.mutation<DataResponse<any>, any>({
      query: (body: any) => ({
        url: `/partner-management/${body?.id}`,
        body,
        method: "DELETE",
        headers: {
          PageName: "Partner Management",
        },
      }),
    }),
  }),
});

export const {
  useGetPartnersQuery,
  useLazyGetDetailPartnerQuery,
  useLazyGetMerchantLinkPartnerQuery,
  useLazyGetPartnersQuery,
  useCreatePartnerMutation,
  useUpdatePartnerMutation,
  useAddMerchantsToPartnerMutation,
  useDeletePartnerMutation,
  useGetPartnerSelectQuery,
  useLazyGetPartnerSelectQuery,
} = partnerService;
